<template>
  <div class="home-page tool-page">
    <Header></Header>
    <div class="mission-content tool-page-content ac crfff">
      <div class="tool-back" @click="back">
        <img src="../../static/images/back.png"/>
      </div>
      <div class="fs50 tool-page-title">{{ $t('Coloring_old_photos') }}</div>
      <div class="css-1asaykn tool-page-panel">
        <div class="css-1asaykn mt20">
          <img style="width: 80%" src="../../static/images/Image_Recolor.jpg"/>
        </div>
        <div class="css-12nj5ib mt30">
          <div style="">{{ $t('Coloring_old_photos_tips') }}</div>
        </div>
        <div id="controlBox" class="oneImageInput tool-upload" @click="handleUploadClick">
          <input type="file" @click.stop="handleFileInputClick" @change="convertToBase64_v2" class="file" accept="image/*" ref="imageInput" mutiple="mutiple">
          <div class="imageInputBox">
            <div class="uploadBox uploadIcon">
              <img style="width:60%;" v-if="imageBase64" :src="imageBase64"/>
              <div class="" v-else>
                <img style="width: 3rem" src="../../static/images/transparent.png">
                <div class="label"> {{ $t('Upload') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tool-generate">
      <button @click="uploadImage" class="button">
        <strong>{{ $t('Recolor') }}</strong></button>
    </div>
    <div class="tool-credit-row">
      <button class="btn btn-blue">{{ $t('ChancesLeft') }}: {{ score }}</button>
      <button class="btn" @click="goPurchaseChances">
        <strong>{{ $t('BuyChances') }}</strong>
        <img src="../../static/images/buy.png"></button>
    </div>
    <Dialog class="result-image-dialog" ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
          <div class="image ac" v-if="imageShow">
            <div class="" style="font-size:1rem;margin-bottom: 1rem;">{{ shouldCopyMediaLink() ? $t('downTips1') : $t('downloadImageTips') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt20">
            <span @click="getResult(1)" :class="{'active':isShowResult==1}">{{ $t('Result') }}</span>
            <span @click="getResult(2)" :class="{'active':isShowResult==2}">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools" v-if="shouldCopyMediaLink()">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div class="input-item2" v-if="isShowResult==1">
                  <input class="input" disabled :value="getDownloadUrl()" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy" v-if="detail.url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
                <div class="input-item2" v-if="isShowResult==2">
                  <input class="input" disabled :value="getDownloadUrl()" type="" placeholder="">
                  <img id="copycode" :data-clipboard-text="getDownloadUrl()" @click="copy" v-if="detail.original_url"
                       style="margin-left: 10px;" width="90" src="../../static/images/Copy.png"/>
                </div>
              </div>
            </div>
          </div>
          <div class="ac mt30" v-else>
            <button class="button fw7" style="width: 100%;font-size: 1rem" @click="downloadImage">{{ $t('downloadImage') }}</button>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog ref="BrowserDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 50rem">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeBrowserDialog" style="text-align: right;margin: 0 auto;font-size: 2rem;">×</div>
        <div class="image ac">
          <div class="" style="font-size:1rem;margin-bottom: 1rem;">{{ $t('copy_project_url') }}</div>
          <div class="img-tools">
            <div class="ac mt20">
              <div class="input-item mt50" style="margin-bottom: 1.5rem;width: 80%">
                <div class="input-item2">
                  <input class="input" v-model="project_url" disabled placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;font-size: 1rem" id="copycode"
                      :data-clipboard-text="project_url" @click="copy" v-if="project_url">{{ $t('copyLink') }}
                <img style="width: 1.2rem" src="../../static/images/copy1.png"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'
import { saveMedia, shouldCopyMediaLink } from '../utils/mediaDownload'
import { readCompressedPhoto } from '../utils/photoUpload'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      project_url: ""
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.project_url = this.getProjectUrl()
    this.getHome();
  },
  methods: {
    shouldCopyMediaLink,
    getProjectUrl() {
      const token = localStorage.getItem('token') || ''
      const lang = this.$i18n.locale || localStorage.getItem('lang') || 'bur'
      const params = new URLSearchParams()
      if (token) params.set('token', token)
      params.set('lang', lang)
      return 'https://camem-app.snapai.asia?' + params.toString()
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      const file = event.target.files[0];
      if (!file) return;
      event.target.value = '';
      this.imageBase64 = null;
      this.imageTpye = '';
      readCompressedPhoto(file).then(({ content, type }) => {
        this.imageBase64 = content;
        this.imageTpye = type;
      }).catch(error => {
        this.$utils.alertText(this.$t(error.message === 'photoTooLarge' ? 'photoTooLarge' : 'photoReadFailed'), 100, 4000);
      });
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    },
    uploadImage() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        product_type: 'old_pic_color'
      }

      // that.$refs.imgDialog.showMaskFun();
      // return;
      that.$parent.loadModal(true);
      that.$api.post('/api/product/create', data, r => {
        if (r.code == 0) {
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg, 100);
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$parent.loadModal(false);
          that.getHome()
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      this.downloadImage()
    },
    getDownloadUrl() {
      return this.isShowResult == 1
        ? (this.detail.download_url || this.detail.url)
        : (this.detail.download_original_url || this.detail.original_url)
    },
    downloadImage() {
      const imageUrl = this.getDownloadUrl()
      saveMedia(imageUrl)
    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 新增点击上传入口
    handleUploadClick() {
      if (this.isAndroidWebView()) {
        this.openBrowserDialog();
        return;
      }
      this.$refs.imageInput.click();
    },
    handleFileInputClick(event) {
      if (!this.isAndroidWebView()) return;
      event.preventDefault();
      this.openBrowserDialog();
    },
    isAndroidWebView() {
      const ua = navigator.userAgent || '';
      // 1. 先确认是Android设备
      if (!/Android/i.test(ua)) return false;

      const isWeChat = /MicroMessenger/i.test(ua);
      const isVivoBrowser = /VivoBrowser/i.test(ua);
      const isMiuiBrowser = /MiuiBrowser/i.test(ua);
      const isHuaweiBrowser = /HuaweiBrowser/i.test(ua);

      // 2. 检测明确的WebView特征
      const hasWebViewMarkers = (
        /\bwv\b/.test(ua) ||          // 标准WebView标记
        /; wv\)/.test(ua) ||          // 另一种WebView格式
        /WebView/.test(ua) ||         // 部分OEM厂商的WebView
        /XWEB_/.test(ua)              // 微信XWEB内核
      );
      // 3. 排除已知浏览器（更严格的白名单）
      const isNormalBrowser = (
        /Chrome\/[.0-9]+ Mobile Safari\/[.0-9]+/.test(ua) &&
        !/; wv\)/.test(ua)            // 确保不是WebView伪装的Chrome
      );

      // ✅ 排除特定厂商浏览器（如 Vivo 浏览器）
      const isTrustedBrowser = isVivoBrowser || isMiuiBrowser || isHuaweiBrowser;

      return !isNormalBrowser && !isTrustedBrowser && (hasWebViewMarkers || !/Chrome\//.test(ua));
      // return hasWebViewMarkers || !isNormalBrowser;
    },
    // 跳转系统浏览器
    openInBrowser() {
      this.$utils.alertText(this.$t('redirect_tip'), 100);
      const mobile = localStorage.getItem('mobile') || '';
      const currentUrl = new URL(window.location.href);
      const baseUrl = currentUrl.origin + currentUrl.pathname;
      const hash = currentUrl.hash; // #/sexPicture?type=1
      const hashUrl = new URL(hash.slice(1), 'http://temp');
      hashUrl.searchParams.set('mobile', mobile);
      const finalUrl = `${baseUrl}#${hashUrl.pathname}?${hashUrl.searchParams.toString()}`;
      const schemeLessUrl = finalUrl.replace(/^https?:\/\//, '');
      const fallbackUrl = encodeURIComponent(finalUrl);
      const intentUrl = `intent://${schemeLessUrl}#Intent;scheme=https;S.browser_fallback_url=${fallbackUrl};end`;
      window.location.href = intentUrl;
    },
    openBrowserDialog() {
      this.project_url = this.getProjectUrl()
      this.$refs.BrowserDialog.showMaskFun();
    },
    closeBrowserDialog() {
      this.$refs.BrowserDialog.closeMask();
    }
  }
}
</script>
<style>
input.iosSwitch {
  position: relative;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  width: 80px;
  height: 40px;
  background-color: #fff;
  border: 1px solid #d9dadc;
  border-radius: 50px;
  box-shadow: inset -20px 0 0 0 #fff;
  margin-right: 15px;
}

input.iosSwitch:after {
  content: "";
  position: absolute;
  top: 1px;
  left: 1px;
  background: 0 0;
  width: 46px;
  height: 36px;
  border-radius: 50%;
  box-shadow: 2px 4px 6px rgba(0, 0, 0, .2);
}

input.iosSwitch:checked {
  box-shadow: inset 20px 0 0 0 #0062ff;
  border-color: #0062ff
}

input.iosSwitch:checked:after {
  left: 20px;
  box-shadow: -2px 4px 3px rgba(0, 0, 0, .05);
}

.imageInputBox {
  padding: 3rem 3rem;
  min-height: 4rem;
}

#activeFormBox input.file, #controlBox input.file {
  width: 100%;
  //min-height:300px;
  opacity: 0;
  overflow: hidden;
  z-index: 10;
  position: absolute;
  left: 0;
  top: 0px;
  bottom: 0;
}

.oneImageInput {
  background: #020e5bb8;
  border-radius: 1rem;
  box-shadow: 0 0 0.5rem #49c1ff;
  border: 0.1rem solid #fff;
}

.oneImageInput-content {
  position: relative;
}

.withScratchBox {
  box-shadow: 0 0 20px #49c1ff;
  padding: 40px;
  border-top: 2px solid #fff;
}

.uploadIcon .label {
  color: #5562af;
  margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/page/oldPicColor.vue